export const brandColors = {
  safe: '#28A745',
  normal: '#FFC107',
  warning: '#FF9800',
  danger: '#F44336',
}

export const chartSettings = {
  height: '250px'
}